<div class="switch-board">
  <div class="switch-board__header">
    <!-- Volunteer hand-with-heart icon rendered as a CSS background (see .switch-board__icon-badge). -->
    <div class="switch-board__icon-badge" aria-hidden="true"></div>
    <p class="switch-board__title">{{ titleKey() | translateLang }}</p>
  </div>

  <p class="switch-board__description">{{ descriptionKey() | translateLang }}</p>

  <button type="button" class="switch-board__button" (click)="onLearnMoreClick()">
    <span class="switch-board__button-label">{{ learnMoreKey() | translateLang }}</span>
    @if (showRedirectIcon()) {
      <app-icon
        class="switch-board__button-icon"
        name="external-link"
        [size]="20"
        color="#303030">
      </app-icon>
    }
  </button>
</div>
